// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";
// // import "../styles/restricted.css";
// // import RestrictedImportPage1 from "../../assets/import-restricted-1.png";
// // import  RestrictedImportPage2 from "../../assets/import-restricted-2.png";
// // import RestrictedImportPage3 from "../../assets/import-restricted-3.png";
// // import RestrictedImportPage4  from "../../assets/import-restricted-4.png";

// const faqData = [
//   {
//     q: "1. Applying for Advance Authorisation Scheme",
//         a: (
//         <>
//             <h2>Q.1. How to apply for Advance Authorisation (AA)?</h2>
//                 <p>The steps to apply for Advance Authorisation are as follows.</p>
//                 <ul>
//                   <li>Register on the official DGFT Website via https://www.dgft.gov.in/.</li>
//                   <li>Then, link your existing IEC, if any.</li>
//                   <li>Navigate to My Dashboard & click on View & Register Digital Signatures Token.</li>
//                   <li>Once your registration is complete, you can apply for the scheme under the Services Column.</li>
//                 </ul>

//                 <h2>Q.2. Where to apply for AA?</h2>
//                 <p>You can find the link on the DGFT website, https://www.dgft.gov.in/. Under the service section, you will get the link to apply for Advance Authorisation.</p>

//                 <h2>Q.3. How to link the norms agreed upon by the committee in your AA application form?</h2>
//                 <p>You can link the norms agreed upon by the committee in your AA application form by following the steps below.</p>
//                 <ul>
//                   <li>Open your AA application form and go to the export details menu.</li>
//                   <li>You will find a section stating the norms of the committee meeting where you can click yes or no.</li>
//                   <li>Click yes if the meeting took place before 2020 but digitized export details are not present in the system.</li>
//                   <li>Enter the meeting number, date, & HQ file number to proceed with approved norms.</li>
//                   <li>If you select no, meeting details may reflect in the grid. Use the view export link button to input export items.</li>
//                   <li>Ensure export & input items correspond.</li>
//                   <li>Click add to include all export items in the grid.</li>
//                   <li>Edit each item and re-enter the required quantities.</li>
//                   <li>Based on entered details and approved norms, directions will appear on the screen.</li>
//                 </ul>

//                 <h2>Q.4. What is the required minimum value addition for advance authorization?</h2>
//                 <p>You need to add a minimum value of 15% for Advance Authorisation. However, some export products listed in Appendix 4D allow less than 15% value addition. Tea export requires a minimum value addition of 50%.</p>

//                 <h2>Q.5. How can you add invalidation and indigenously procured item or supplier details in your AA application form?</h2>
//                 <p>When you want to add details regarding invalidation, follow these steps.</p>
//                 <ul>
//                   <li>Open your AA application form and click the Additional Input button.</li>
//                   <li>Under invalidation details, select input item and add it to the grid.</li>
//                   <li>Click the edit icon and enter the quantity to be invalidated.</li>
//                   <li>Click Save.</li>
//                 </ul>
//                 <p>To enter Indigenously Procured Items or Supplier details, follow these steps.</p>
//                 <ul>
//                   <li>Click on Indigenous Supplier details or SEZ supplier details.</li>
//                   <li>Select input items from the drop-down list.</li>
//                   <li>Enter procurement quantity and click add.</li>
//                   <li>Add supplier details like IEC or Branch Code.</li>
//                   <li>Click Add to save.</li>
//                 </ul>

//                 <h2>Q.6. How can you input wastage claim details for any existing item in your AA application form?</h2>
//                 <p>Here are the steps to input wastage claim details in the AA application form.</p>
//                 <ul>
//                   <li>Open your AA application and click the Additional Input tab.</li>
//                   <li>Go to the wastage claim section and select input item.</li>
//                   <li>Tick and add items from the grid.</li>
//                   <li>Click the edit icon and enter justification & wastage claim percentage.</li>
//                   <li>Click Update.</li>
//                 </ul>

//                 <h2>Q.7. How much is the validity period for the import of AA?</h2>
//                 <p>12 months from the issue date of authorization is the validity period for the import of AA.</p>

//                 <h2>Q.8. What does the AA application form charge?</h2>
//                 <p>If you want a certificate, license, permission, advance authorization, DFIA, or EPCG authorization for restricted items, the application charge is one per thousand, with a minimum of Rs. 500 and a maximum of Rs. 100000 depending on CIF value or duty of authorization.</p>

//                 <h2>Q.9. Where to see your CBIC transmission details for AA?</h2>
//                 <p>You can view your CBIC transmission details for AA by following these steps.</p>
//                 <ul>
//                   <li>Enter your registered AA file number.</li>
//                   <li>Go to My Dashboard and click Submitted Applications.</li>
//                   <li>Select AA under Type of Scheme.</li>
//                   <li>Select issuance of AA under Type of Application.</li>
//                   <li>In the action section, click transmission details.</li>
//                 </ul>

//                 <h2>Q.10. How to cancel AA Authorization?</h2>
//                 <p>You can surrender your issued AA authorization by filing a Closure of AA application.</p>

//                             </>
//     ),
//   },
//   {
//     q: "2. Invalidation of Advance Authorisation",
//      a: (
//         <>
//                   <h2>Q1. How to apply for AA invalidation?</h2>
//             <p>When you want to apply for AA invalidation, follow these steps.</p>
//             <ul>
//               <li>Go to the services column after signing in with your file number and open the AA section.</li>
//               <li>Click on the invalidation of advance authorization option.</li>
//               <li>Start applying or select an existing draft.</li>
//               <li>For a fresh application, click the authorization for invalidation button and fill out the form.</li>
//               <li>Pay the application fees and submit the application.</li>
//             </ul>

//             <h2>Q2. How to add invalidation/indigenously procured item/supplier details in the AA invalidation application form?</h2>
//             <p>Follow the steps below to add invalidation details to your AA invalidation form.</p>
//             <ul>
//               <li>Open your application form and click the Additional Input button.</li>
//               <li>Go to the invalidation details section and click Select Input Item.</li>
//               <li>Tick the item you want to add from the drop-down list.</li>
//               <li>Click the edit icon for the added items.</li>
//               <li>Enter the quantity you want to invalidate and click Save.</li>
//             </ul>
//             <p>Follow these steps to add supplier or indigenously procured item details.</p>
//             <ul>
//               <li>Click the Indigenous Supplier Details or SEZ Supplier Details option.</li>
//               <li>Select the serial number of the input item from the drop-down list.</li>
//               <li>Enter the quantity you want to procure from the supplier.</li>
//               <li>Click Add and enter details like IEC number, branch code, etc.</li>
//               <li>Click Add again to save.</li>
//             </ul>

//             <h2>Q3. How much does applying for invalidation of advance authorization cost?</h2>
//             <p>You can amend or correct your issued authorization and apply for invalidation at a cost of Rs. 200 only.</p>

//                         </>
//   ),
// },
// {
//     q: "3. Revalidation of Advance Authorisation",
//       a: (
//         <>
//             <h2>Q1. How to apply for AA revalidation?</h2>
//             <p>Here are the steps to follow when applying for AA revalidation.</p>
//             <ul>
//               <li>Navigate to the Services Column and click on Advance Authorization.</li>
//               <li>Click on the Revalidation of Advance Authorization tab.</li>
//               <li>Start applying or select an existing draft application.</li>
//               <li>If applying fresh, select the authorization for revalidation option.</li>
//               <li>Fill out the application form, make the payment, and click the submit button.</li>
//             </ul>

//             <h2>Q2. How much does the first revalidation for AA cost?</h2>
//             <p>The first revalidation application form for AA costs Rs. 500.</p>

//             <h2>Q3. How much does the second revalidation for AA cost?</h2>
//             <p>The second revalidation application form for AA costs Rs. 1000.</p>

//             <h2>EO-Extension of Advance Authorisation</h2>
//             <p>This section explains the process for EO-extension of Advance Authorisation.</p>

//             <h2>Q4. How to apply for EO-extension of AA?</h2>
//             <p>Follow the steps below to apply for EO-extension of AA.</p>
//             <ul>
//               <li>Go to Services, then Advance Authorization, and select EO-extension of advance authorization.</li>
//               <li>Start applying or choose an existing draft.</li>
//               <li>If applying fresh, select authorization for EO-extension.</li>
//               <li>Fill out the form, make the payment, and submit the application.</li>
//             </ul>
//             </>
//     ),
//   },
//   {
//     q: "4. Amendment of Advance Authorisation",
//  a: (
//         <>
//             <h2>Q1. How to apply for AA revalidation?</h2>
//             <p>Follow the given steps to apply for AA revalidation.</p>
//             <ul>
//               <li>Navigate to the Services menu, then go to Advance Authorization, and select Amendment of Advance Authorization.</li>
//               <li>Either select an existing application draft or start a fresh application.</li>
//               <li>For a fresh application, click on Authorization for Amendment.</li>
//               <li>Fill out the form, make the payment, and submit the application.</li>
//             </ul>
//             </>
//     ),  },
//   {
//     q: "5. Closure / Clubbing & Closure of Advance Authorisation ",
//     a: (
//         <>
//             <h2>Q.1. How to close your AA file?</h2>
//             <p>If you want to close your AA file, follow the steps below.</p>
//             <ul>
//               <li>Go to Services Menu, then Advance Authorization, and select Closure of Advance Authorization from the drop-down options.</li>
//               <li>Start a new application or select an existing draft.</li>
//               <li>If filing a fresh application, choose Authorization for Closure.</li>
//               <li>Complete the form, pay the fee, and submit the application.</li>
//             </ul>

//             <h2>Q2. How to apply for Clubbing &amp; Closure of AA?</h2>
//             <p>If you want to apply for Clubbing &amp; Closure of AA, follow these steps.</p>
//             <ul>
//               <li>Go to the Services column, navigate to Advance Authorization, and select Clubbing &amp; Closure of AA.</li>
//               <li>Choose whether to start a new application or select an existing draft.</li>
//               <li>When filing fresh, select two or more authorizations to be clubbed for closure.</li>
//               <li>Fill out the form, pay the charges, and submit it for processing.</li>
//             </ul>

//             <h2>Q3. How to surrender AA registration?</h2>
//             <p>You need to apply for Closure of Advance Authorization to surrender your AA registration. If no exports or imports are made, go to the redemption matrix, check the details under the Surrender section, verify the application, and submit it to RA for approval.</p>
//                         </>
//          ),
//          },
    
// ];

// export default function AdvanceAuthorisation() {
//   return (
//   <>
// <div className="bg-light py-5">
//       {/* LEFT FLOATING */}
//       {/* <div className="left-fixed">
//         <div>FAQ's</div>
//         <div>FTP 2023</div>
//         <div>HBP 2023</div>
//       </div> */}

//       {/* RIGHT BROCHURE */}
//       {/* <div className="brochure">CORPORATE BROCHURE</div> */}

//       {/* WHATSAPP */}
//       {/* <div className="whatsapp">🟢</div> */}
//         <section className="bg-light">
//         <Container>
//           <Row className="g-4 align-items-start">
//             {/* LEFT CONTENT */}
//             <Col lg={8}>
//               <div>
  
//                 <h1> Advance Authorisation (Advance licence) </h1>
//                                   <p>Import and Export is a wealthy field of business and if done right can make you millions, but it does have its drawbacks. The biggest setback is the rules/fees/authorizations, since you are doing business with another country, the Indian government has a definite set of rules you must follow to make the sale or purchase. This set of rules make most people pull back from the thought of running an import-export business. However, once you are into it, the rules seem friendly and the only thing you see is growth. Talking about growth, the Government of India, to boost imports, exports, launches various schemes from time to time to attract businessmen towards the field and one such scheme is the Advance Authorisation Scheme.</p>
//                                   <p>What is the AAS (Advance Authorisation Scheme)? What are its benefits? How can you enroll in it? Who is eligible? These are some of the questions we will try and answer within this blog. If you want, you can also connect with us directly, according to our clients we are the best Advance Authorisation Scheme consultants in India. Without further ado, let’s start with the basics.</p>
         
//                 </div>
//                    </Col>
       
//             <Col lg={4}>
//               <div className="p-4 shadow rounded right-form">
//                 <Form>
//                   <Form.Control className="mb-3" placeholder="Name" />
//                   <Form.Control className="mb-3" placeholder="Email" />
//                   <Form.Control className="mb-3" placeholder="Phone" />
//                   <Form.Control className="mb-3" placeholder="Subject" />
//                   <Button className="w-100">Get Started</Button>
//                 </Form>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>
          
           
//             <section className="bg-light">
//         <Container>
//                       <div>
//                           <h2>What is the Advance Authorisation Scheme? Who is it for?</h2>
//                           <p>Imagine you run a restaurant chain, when you are selling an item you are paying a fee to the government. When you are buying raw material to create that food item you are again paying a huge fee to the government. A fee on both ends would mean little or no incentive for you, right? Now let’s transfer this example to manufacturers who export certain products from India.</p>
//                           <p>The Advance Authorisation Scheme is for those exporters who need to import raw material to create an exportable good, i.e, the raw material they require to manufacture their goods and make them export-ready, whether it’s packing, fuel, oil, etc. is to be imported from a 2nd country.</p>
          
//                           <h2>Why is it needed?</h2>
//                           <p>Now, in a general case scenario, anyone who is importing anything from another country will have to pay import duty on the item and anyone who has to export something will also be liable to show the income amount and pay taxes accordingly. If this case would be applied to exporters who fall in the category mentioned above, they would be at a huge loss, since they would be paying duties at both ends. To help such exporters, the Government of India launched the Advance Authorisation Scheme so that they do not have to pay duties on both ends.</p>
//                          <p>According to this scheme, such exporters would get duty-free imports of material that is used in manufacturing their goods. But, the quantity of such imports is fixed by the GOI for a certain amount of manufactured goods. The DGFT has created a whole list of such exported material that requires a certain material, in certain quantities to be imported. This list has Standard Input-Output Norms (SION) that the investors can apply to.</p>
          
//                           <h2>What are the requirements?</h2>
//                           <p>Well, first you should have an IEC and other requisites as mentioned under the Foreign Trade Policy, Chapter 4, the policy has all other details required to take benefit of the Advance Authorisation Scheme. But this can prove to be very exhausting for exporters since there are multiple documents needed, multiple licenses, and more, failing at any of this can lead to rejection of the import license. So, it would be good if you get help from the best Advance Authorisation Scheme consultants in India.</p>

//                           <h2>What are the benefits of the Advance Authorisation Scheme?</h2>
//                           <p>The most important benefit is that you get exemption from multiple taxes, here is the list of those:</p>
//                           <ul>
//                               <li>Education Cess</li>
//                               <li>Anti-Dumping Duty</li>
//                               <li>Basic Customs Duty</li>
//                               <li>Additional Custom Duty</li>
//                               <li>Countervailing Duty</li>
//                               <li>Safeguard Duty</li>
//                               <li>Duty Drawback (in certain cases where input is not mentioned in norms)</li>
//                               <li>Integrated Tax and Compensation Cess</li>
//                           </ul>

//                           <h2>What is the basis of Advance Authorisation?</h2>
//                           <p>Here, we have listed the basis on which you can take benefit of the Advance Authorisation Scheme.</p>
//                           <p>1. Inputs according to the SION</p>
//                           <p>DGFT has issued certain norms and quantities for all the exports that can take benefit of the inputs, and you can use this list and norms to make the best from the scheme.</p>
//                           <p>1. Self-Declaration</p>
//                           <p>This is very important. Suppose the above norms do not have the list of raw materials or the right quantity of inputs you need for manufacturing. In this case, you can file a self-declaration with the number of inputs you need for x amount of manufactured goods. The RA will process the authorization and you will get to import the inputs duty-free. But, the norms committee will check and approve the claims made by you.</p>
//                           <p>These two options are used very commonly and are available to all exporters who need to claim inputs under the Advance Authorisation Scheme.</p>
//                           <p>Of course, all of this requires a lot of licenses and mandates and again if you need help with these, you can connect with the best Advance Authorisation scheme consultants in India.</p>
          
//                           <h2>At Apex Services What We Do</h2>
//                           <p>The factors used in the manufacturing process of the export product could be eligible for getting imported under the scheme. We help in the identification of the eligibility and gaining the benefits of AA. We go through the different functioning processes or norms followed to acquire the AA. Furthermore, there is guidance in the requirement and compliance followed by the Clients once the authorization is issued. Getting Redemption Letter from DGFT RA and release of Bond/BG after fulfilling the export obligation from Customs.</p>
//                       </div>
//         </Container>
//       </section>

//       {/* FAQ */}
            
//             <section className="py-5 bg-light faq-section">
//           <Container>
//             <h2 className="mb-4 faq-title">
//           Frequently Asked Questions on Importer-Exporter Code (IEC)/(E-IEC)
//           </h2>

//            <Accordion defaultActiveKey="0" className="custom-faq">
//             {faqData.map((f, i) => (
//               <Accordion.Item eventKey={String(i)} key={i}>
//                 <Accordion.Header>{f.q}</Accordion.Header>
//                 <Accordion.Body>{f.a}</Accordion.Body>
//               </Accordion.Item>
//             ))}
//           </Accordion>
//         </Container>
//         </section>
//         </div>
//     </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaHandsHelping,
  FaExclamationTriangle
} from "react-icons/fa";

export default function AdvanceAuthorisation() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Advance Authorisation (Advance License)
              </h1>

              <p>
                Advance Authorisation is a key export incentive scheme under
                India’s Foreign Trade Policy that allows duty-free import of
                inputs required for manufacturing export products.
              </p>

              <p>
                It helps exporters reduce costs, improve margins, and compete
                effectively in global markets.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form here */}
            </Col>
          </Row>

          {/* PURPOSE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Purpose of Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Duty-free import of raw materials</li>
            <li><FaCheckCircle /> Reduce manufacturing costs</li>
            <li><FaCheckCircle /> Improve export competitiveness</li>
            <li><FaCheckCircle /> Promote export-driven growth</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Who Can Apply
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Manufacturer exporters</li>
            <li><FaCheckCircle /> Merchant exporters with supporting manufacturers</li>
            <li><FaCheckCircle /> Exporters with confirmed or expected orders</li>
            <li><FaCheckCircle /> Businesses engaged in export production</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Apply through DGFT portal</li>
            <li><FaCheckCircle /> Submit product and input details</li>
            <li><FaCheckCircle /> DGFT verification</li>
            <li><FaCheckCircle /> License issuance</li>
          </ul>

          {/* CONDITIONS */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Key Conditions
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Inputs must be used for export production</li>
            <li><FaCheckCircle /> Export obligation must be fulfilled</li>
            <li><FaCheckCircle /> Maintain proper records</li>
            <li><FaCheckCircle /> Non-compliance leads to penalties</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Duty-free imports</li>
            <li><FaCheckCircle /> Reduced production cost</li>
            <li><FaCheckCircle /> Access to global raw materials</li>
            <li><FaCheckCircle /> Improved product quality</li>
            <li><FaCheckCircle /> Additional GST & duty benefits</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Documents Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> IEC Certificate</li>
            <li><FaCheckCircle /> Export order / contract</li>
            <li><FaCheckCircle /> Bill of Materials</li>
            <li><FaCheckCircle /> Technical specifications</li>
            <li><FaCheckCircle /> GST details</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including
            eligibility assessment, documentation, application filing,
            DGFT coordination, and post-license compliance.
          </p>

        </Container>
      </section>
    </div>
  );
}